export default class Module {

  constructor( api, name ) {
    this.name = name
    this.api = api.child( `module/${name}` )
  }

  get( opts ) {
    return this.api.get( opts )
  }

  update( update ) {
    return this.api.patchRaw( update )
  }

  delete( ) {
    return this.api.delete( )
  }
}
